import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { BusinessProfileResponse, BusinessProfileUpdateRequest } from "@/api/types";

export function useUpdateBusinessProfile(businessId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: BusinessProfileUpdateRequest) =>
      api.patch(`businesses/${businessId}/profile`, { json: data }).json<BusinessProfileResponse>(),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["onboarding-status"] });
    },
  });
}
